// import toPairs from 'lodash/toPairs'
import { HttpService, HttpServiceResponse } from '../shared'
import { LoginResult, UserPasswordChange, UserVerifyResult } from './auth.types'

export class AuthProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return this.baseUrl
  }

  public login(
    username: string,
    password: string,
    otp?: string,
    otpHash?: string,
  ): Promise<HttpServiceResponse<LoginResult>> {
    return this.http.post(`${this.url}/logon2_api.php?`, {
      username,
      password,
      otp,
      otphash: otpHash,
    })
  }

  public logout(): Promise<HttpServiceResponse<void>> {
    return this.http.post(`${this.url}/logout_api.php`)
  }

  public changePasswordForced(
    username: string,
    password: string,
    newPassword: string,
    otp: string,
  ): Promise<HttpServiceResponse<void>> {
    return this.http.post(`${this.url}/logon2_api.php`, {
      username,
      password,
      newpassword: newPassword,
      otp,
    })
  }

  public verifyPasswordChangeOTP(username: string, number: string): Promise<HttpServiceResponse<UserVerifyResult>> {
    return this.http.post(`${this.url}/recover_api.php?action=verify`, {
      UserName: username,
      CellPhone: number,
    })
  }

  public resetPassword(
    username: string,
    cellphone: string,
    newpass: string,
    code: string,
  ): Promise<HttpServiceResponse<UserPasswordChange>> {
    return this.http.post(`${this.url}/recover_api.php?action=changepass`, {
      UserName: username,
      CellPhone: cellphone,
      NewPass: newpass,
      Code: code,
    })
  }
}
